import axios from 'axios';

import type { Tag } from '../../@types/types';
import { getRequestAuth } from '../helpers/getRequestAuth';

export const fetchTags = async (authToken: string): Promise<Tag[]> => {
  const auth = await getRequestAuth(authToken);

  const response = await axios({
    method: 'get',
    url: `${process.env.REACT_APP_API_URL}/tags${auth.authProvider === 'al' ? '-spa-al' : ''}`,
    headers: {
      'Content-Type': 'application/json',
      Authorization: auth.token,
    },
  });

  return response.data;
};
